module.exports = __webpack_public_path__ + "components/star-rating/static/yellow/1-46a100202d6882cb72d4dd5ede02e1dc.svg";